import React, { forwardRef } from 'react';
import cn from 'classnames';
import { PaginationVariantProps } from '../types';

import transition from '../../styles/transition';
import IconButton from '../../Buttons/IconButton';

const DefaultS = forwardRef<HTMLDivElement, PaginationVariantProps>(
  (
    {
      currentPage = 1,
      totalPages = 1,
      onPrev,
      onNext,
      dark,
      className,
      ...other
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={cn('flex items-center justify-between', className)}
      {...other}
    >
      <IconButton
        arrow="left"
        xs
        darkMode={dark}
        disabled={currentPage <= 1}
        onClick={onPrev}
      />
      <div className="flex items-center">
        {Array.from({ length: totalPages }).map((_, i) => (
          <div
            key={`pag-dot-${i * 1}`}
            className={cn(
              'w-12 h-12 rounded-full mx-8 flex-shrink-0',
              i + 1 === currentPage
                ? 'bg-primary-main'
                : 'bg-gray-dark-24',
            )}
            style={{ transition: transition('background-color') }}
          />
        ))}
      </div>
      <IconButton
        arrow="right"
        xs
        darkMode={dark}
        disabled={currentPage >= totalPages}
        onClick={onNext}
      />
    </div>
  ),
);

export default DefaultS;
